import React, { useState } from "react";
import api from "../services/api";
export default function NotificationsPage() {
  const [form, setForm] = useState({ title: "", body: "", topic: "all_citizens" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const handleSend = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/notifications/send/", form);
      setSent(true);
      setForm({ title: "", body: "", topic: "all_citizens" });
      setTimeout(() => setSent(false), 3000);
    } catch { alert("Erreur lors de l envoi"); }
    finally { setLoading(false); }
  };
  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ color: "#1A1A2E", fontSize: 24, fontWeight: 800, margin: 0 }}>Notifications Push</h1>
        <p style={{ color: "#8A8A9A", fontSize: 14, margin: "4px 0 0" }}>Envoyez des notifications aux citoyens</p>
      </div>
      {sent && (
        <div style={{ background: "#1A5C2A20", border: "1px solid #1A5C2A40", borderRadius: 14, padding: 16, marginBottom: 20, display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ fontSize: 24 }}>✅</span>
          <p style={{ margin: 0, color: "#1A5C2A", fontWeight: 600 }}>Notification envoyée avec succès!</p>
        </div>
      )}
      <div style={{ background: "white", borderRadius: 20, padding: 28, boxShadow: "0 4px 12px rgba(0,0,0,0.06)" }}>
        <form onSubmit={handleSend}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#1A1A2E", marginBottom: 6 }}>Destinataires</label>
            <select value={form.topic} onChange={e => setForm({...form, topic: e.target.value})}
              style={{ width: "100%", padding: "12px 14px", border: "1px solid #E8E8F0", borderRadius: 12, fontSize: 14, fontFamily: "Poppins", outline: "none" }}>
              <option value="all_citizens">Tous les citoyens</option>
              <option value="agents">Agents municipaux</option>
            </select>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#1A1A2E", marginBottom: 6 }}>Titre *</label>
            <input value={form.title} onChange={e => setForm({...form, title: e.target.value})} required placeholder="Ex: Nouvelle actualite importante"
              style={{ width: "100%", padding: "12px 14px", border: "1px solid #E8E8F0", borderRadius: 12, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box" }} />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#1A1A2E", marginBottom: 6 }}>Message *</label>
            <textarea value={form.body} onChange={e => setForm({...form, body: e.target.value})} required rows={4} placeholder="Contenu de la notification..."
              style={{ width: "100%", padding: "12px 14px", border: "1px solid #E8E8F0", borderRadius: 12, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box", resize: "vertical" }} />
          </div>
          <button type="submit" disabled={loading}
            style={{ background: loading ? "#8A8A9A" : "linear-gradient(135deg, #0F3D1A, #1A5C2A)", color: "white", border: "none", padding: "14px 32px", borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer", fontFamily: "Poppins" }}>
            {loading ? "Envoi en cours..." : "🔔 Envoyer la notification"}
          </button>
        </form>
      </div>
      <div style={{ background: "white", borderRadius: 20, padding: 24, marginTop: 20, boxShadow: "0 4px 12px rgba(0,0,0,0.06)" }}>
        <h3 style={{ color: "#1A1A2E", fontSize: 16, fontWeight: 700, margin: "0 0 16px" }}>Conseils</h3>
        {[
          { icon: "📰", tip: "Envoyez une notification quand vous publiez une nouvelle actualite importante." },
          { icon: "🚨", tip: "Pour les urgences, utilisez un titre court et clair comme URGENT: ..." },
          { icon: "📅", tip: "Rappelez les evenements 24h avant pour maximiser la participation." },
          { icon: "💰", tip: "Notifiez les citoyens avant les echeances de paiement de taxes." },
        ].map((item, i) => (
          <div key={i} style={{ display: "flex", gap: 12, padding: "10px 0", borderBottom: i < 3 ? "1px solid #F5F6FA" : "none" }}>
            <span style={{ fontSize: 20 }}>{item.icon}</span>
            <p style={{ margin: 0, fontSize: 13, color: "#8A8A9A", lineHeight: 1.5 }}>{item.tip}</p>
          </div>
        ))}
      </div>
    </div>
  );
}